import { useMutation } from '@tanstack/react-query';
import { fetchSpin } from './service';
import { LuckySpinRewards } from '@/models/userReward/lucky-spin/lucky-spin-rewards';
import { useDispatch } from 'react-redux';
import {
  setLuckySpinIsSpinning,
  setLuckySpinPrize,
} from '@/lib/store/lucky-spin/actions';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { ErrorService } from '@/services/ErrorService';

export function useSpin() {
  const dispatch = useDispatch();

  function onSuccess(data: LuckySpinRewards) {
    dispatch(setLuckySpinIsSpinning(true));
    dispatch(setLuckySpinPrize(data));
  }

  function onError(error: AxiosError<GenericError>) {
    ErrorService.onError(error);
  }

  const { isPending: isLoading, mutate } = useMutation({
    mutationFn: fetchSpin,
    onSuccess,
    onError,
  });

  return { isLoading, spin: mutate };
}
